import { Drawer, Grid, Icon, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { DrawerList } from "../../Data";
import { RootState } from "../../Redux/UserSlice";
import {
  getNavigationPath,
  getShowModal,
} from "../../Redux/DetailsofProfileSlice";
import CustomModal from "../Modal/CustomModal";
import AsscessDeniedModal from "../Modal/AsscessDeniedModal";
import { changeClassRoomValue } from "../../Redux/ClassroomSlice";

interface StateType {
  tour: {
    value: number;
    previousPage: string;
  };
}

interface StateType {
  classRoom: {
    classroomPage: any;
    enrolledCourse: any;
    coursestatus: any;
  };
}
interface StateType {
  profileDetails: {
    editSatus: any;
    showModal: any;
  };
}
export default function Drawers() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const path = location.pathname;
  const [show, setShow] = useState(false);
  const Tour = useSelector((state: StateType) => state.tour.value);
  const userRole = useSelector((state: RootState) => state.user.role);
  const enrolledCourse = useSelector(
    (state: StateType) => state.classRoom.enrolledCourse || []
  );

  const nextPage = useSelector(
    (state: StateType) => state.classRoom.classroomPage
  );
  const setEdit = useSelector(
    (state: StateType) => state.profileDetails.editSatus
  );
  const { coursestatus } = useSelector((state: StateType) => state.classRoom);
  const LastViewed = useSelector((state: StateType) => state.tour.previousPage);

  const [value, setValue] = useState(Tour);
  const [isHovered, setIsHovered] = useState<number | null>(null);

  const handleMouseEnter = (index: number) => {
    setIsHovered(index);
  };

  const handleMouseLeave = () => {
    setIsHovered(null);
  };

  const handleChange = (navigatePath: string) => {
    if (
      path === "/landing/classroom" &&
      nextPage !== 1 &&
      nextPage !== 0 &&
      coursestatus !== "COMPLETED"
    ) {
      setShow(true);
    } else if (path === "/landing/profile" && setEdit === true) {
      dispatch(getShowModal(true));
      dispatch(getNavigationPath(navigatePath));
    } else {
      dispatch(changeClassRoomValue(enrolledCourse[0]?.courseDetails.CID));
      navigate(navigatePath);
    }
  };

  useEffect(() => {
    setValue(Tour - 1);
  }, [Tour]);

  return (
    <>
      <Drawer variant="permanent" className="Side">
        <Grid container className="flexColumn">
          {DrawerList.filter((role) => role.roles.includes(userRole)).map(
            (i, index) => {
              const isSelected = path === i.navigate;
              const IconComponent = isSelected ? i.selectedIcon : i.icon;

              return (
                <Grid
                  key={index}
                  item
                  className={clsx("Drawer", {
                    focus: isSelected,
                    hover:
                      !(
                        path === "/landing/classroom" &&
                        nextPage !== 1 &&
                        nextPage !== 0 &&  coursestatus !== "COMPLETED"
                      ) && path !== i.navigate,
                    disable:
                      path === "/landing/classroom" &&
                      nextPage !== 1 &&
                      nextPage !== 0 &&  coursestatus !== "COMPLETED",
                    tourHover:
                      path === "/landing/activity" &&
                      LastViewed === "/signup" &&
                      value === index,
                  })}
                  onMouseEnter={() =>
                    !(
                      path === "/landing/classroom" &&
                      nextPage !== 1 &&
                      nextPage !== 0 &&  coursestatus !== "COMPLETED"
                    ) && handleMouseEnter(index)
                  }
                  onMouseLeave={handleMouseLeave}
                  onClick={() => handleChange(i.navigate)}
                >
                  <Icon>
                    <IconComponent
                      // color={
                      //   path === i.navigate ||
                      //   isHovered === index ||
                      //   (path === "/landing/activity" &&
                      //     LastViewed === "/signup" &&
                      //     value === index)
                      //     ? "info"
                      //     : "action"
                      // }
                      color={
                        isSelected || isHovered === index ? "info" : "action"
                      }
                      sx={{
                        fontSize: "24px",
                        cursor:
                          path === "/landing/classroom" &&
                          nextPage !== 1 &&
                          nextPage !== 0 &&  coursestatus !== "COMPLETED"
                            ? "default"
                            : "pointer",
                      }}
                    />
                  </Icon>
                  <Typography
                    variant="body1"
                    className={clsx({
                      drawer: path === i.navigate || path !== i.navigate,
                      drawerHoverColor:
                        (path !== i.navigate && isHovered === index) ||
                        (path === "/landing/activity" &&
                          LastViewed === "/signup" &&
                          value === index),
                    })}
                  >
                    {i.name}
                  </Typography>
                </Grid>
              );
            }
          )}
        </Grid>
      </Drawer>
      <CustomModal
        open={show}
        handleClose={() => setShow(false)}
        child={<AsscessDeniedModal setOpen={setShow} open={show} />}
      />
    </>
  );
}
